import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { EventEmitter, Component, HostBinding, Input, Output, HostListener, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FadvBaseComponent, Forward, Track, FadvCommonModule } from '@fa-switch-sharedservices/ng-elements/common';
import '@fa-switch-sharedservices/web-elements/components/tab-group/tab-group';
import '@fa-switch-sharedservices/web-elements/components/tab-panel/tab-panel';
import '@fa-switch-sharedservices/web-elements/components/tab/tab';

class FadvTabComponent extends FadvBaseComponent {
    constructor() {
        super(...arguments);
        this.slotName = 'nav';
        this.active = false;
        this.closable = false;
        this.disabled = false;
        this.tabClosed = new EventEmitter();
        this.tabShown = new EventEmitter();
        this.tabHidden = new EventEmitter();
    }
    _handleTabClosed() {
        this.tabClosed.emit(this.panel);
    }
    handleTabActivate() {
        this.tabShown.emit();
    }
    handleTabDeactivated() {
        this.tabHidden.emit();
    }
}
FadvTabComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvTabComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
FadvTabComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvTabComponent, selector: "fadv-tab", inputs: { active: "active", closable: "closable", disabled: "disabled", panel: "panel" }, outputs: { tabClosed: "tabClosed", tabShown: "tabShown", tabHidden: "tabHidden" }, host: { listeners: { "sl-close": "_handleTabClosed($event)", "sl-tab-activated": "handleTabActivate()", "sl-tab-deactivated": "handleTabDeactivated()" }, properties: { "slot": "this.slotName" } }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvTabComponent.prototype, "active", void 0);
__decorate([
    Forward()
], FadvTabComponent.prototype, "closable", void 0);
__decorate([
    Forward()
], FadvTabComponent.prototype, "disabled", void 0);
__decorate([
    Forward()
], FadvTabComponent.prototype, "panel", void 0);
__decorate([
    Track()
], FadvTabComponent.prototype, "tabClosed", void 0);
__decorate([
    Track()
], FadvTabComponent.prototype, "tabShown", void 0);
__decorate([
    Track()
], FadvTabComponent.prototype, "tabHidden", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvTabComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-tab',
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { slotName: [{
                type: HostBinding,
                args: ['slot']
            }], active: [{
                type: Input
            }], closable: [{
                type: Input
            }], disabled: [{
                type: Input
            }], panel: [{
                type: Input
            }], tabClosed: [{
                type: Output
            }], tabShown: [{
                type: Output
            }], tabHidden: [{
                type: Output
            }], _handleTabClosed: [{
                type: HostListener,
                args: ['sl-close', ['$event']]
            }], handleTabActivate: [{
                type: HostListener,
                args: ['sl-tab-activated']
            }], handleTabDeactivated: [{
                type: HostListener,
                args: ['sl-tab-deactivated']
            }] } });
class FadvTabPanelComponent extends FadvBaseComponent {
    constructor() {
        super(...arguments);
        this.active = false;
    }
}
FadvTabPanelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvTabPanelComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
FadvTabPanelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvTabPanelComponent, selector: "fadv-tab-panel", inputs: { active: "active", name: "name" }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvTabPanelComponent.prototype, "active", void 0);
__decorate([
    Forward()
], FadvTabPanelComponent.prototype, "name", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvTabPanelComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-tab-panel',
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { active: [{
                type: Input
            }], name: [{
                type: Input
            }] } });
class FadvTabGroupComponent extends FadvBaseComponent {
    constructor() {
        super(...arguments);
        this.activation = 'auto';
        this.noScrollControls = false;
        this.placement = 'top';
        this.fluid = false;
        this.tabShown = new EventEmitter();
        this.tabHidden = new EventEmitter();
    }
    _forwardTabShownEvent(event) {
        event.stopPropagation();
        const customEvent = event;
        this.tabShown.emit(customEvent.detail.name);
    }
    _forwardTabHiddenEvent(event) {
        event.stopPropagation();
        const customEvent = event;
        this.tabHidden.emit(customEvent.detail.name);
    }
    ngOnChanges(changes) {
        super.ngOnChanges(changes);
        if (changes.activeTab && changes.activeTab.currentValue && changes.activeTab.currentValue !== changes.activeTab.previousValue) {
            this.elementRef.nativeElement.show(changes.activeTab.currentValue);
        }
    }
}
FadvTabGroupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvTabGroupComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
FadvTabGroupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvTabGroupComponent, selector: "fadv-tab-group", inputs: { activation: "activation", noScrollControls: "noScrollControls", placement: "placement", fluid: "fluid", activeTab: "activeTab" }, outputs: { tabShown: "tabShown", tabHidden: "tabHidden" }, host: { listeners: { "sl-tab-show": "_forwardTabShownEvent($event)", "sl-tab-hide": "_forwardTabHiddenEvent($event)" } }, usesInheritance: true, usesOnChanges: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvTabGroupComponent.prototype, "activation", void 0);
__decorate([
    Forward()
], FadvTabGroupComponent.prototype, "noScrollControls", void 0);
__decorate([
    Forward()
], FadvTabGroupComponent.prototype, "placement", void 0);
__decorate([
    Forward()
], FadvTabGroupComponent.prototype, "fluid", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvTabGroupComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-tab-group',
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { activation: [{
                type: Input
            }], noScrollControls: [{
                type: Input
            }], placement: [{
                type: Input
            }], fluid: [{
                type: Input
            }], activeTab: [{
                type: Input
            }], tabShown: [{
                type: Output
            }], tabHidden: [{
                type: Output
            }], _forwardTabShownEvent: [{
                type: HostListener,
                args: ['sl-tab-show', ['$event']]
            }], _forwardTabHiddenEvent: [{
                type: HostListener,
                args: ['sl-tab-hide', ['$event']]
            }] } });

class FadvTabsModule {
}
FadvTabsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvTabsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FadvTabsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: FadvTabsModule, declarations: [FadvTabGroupComponent, FadvTabComponent, FadvTabPanelComponent], imports: [FadvCommonModule], exports: [FadvTabGroupComponent, FadvTabComponent, FadvTabPanelComponent] });
FadvTabsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvTabsModule, imports: [FadvCommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvTabsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FadvTabGroupComponent, FadvTabComponent, FadvTabPanelComponent],
                    imports: [FadvCommonModule],
                    exports: [FadvTabGroupComponent, FadvTabComponent, FadvTabPanelComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FadvTabComponent, FadvTabGroupComponent, FadvTabPanelComponent, FadvTabsModule };
